import { render, staticRenderFns } from "./moveTheaterdata.vue?vue&type=template&id=7c22584c&"
import script from "./moveTheaterdata.vue?vue&type=script&lang=js&"
export * from "./moveTheaterdata.vue?vue&type=script&lang=js&"
import style0 from "./moveTheaterdata.vue?vue&type=style&index=0&id=7c22584c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports